import { render, staticRenderFns } from "./OpeningHoursRow.vue?vue&type=template&id=ad694fae&"
import script from "./OpeningHoursRow.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursRow.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursRow.vue?vue&type=style&index=0&id=ad694fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports